import { NewPageList } from "./new-page-list";

export class Exhibitor {
    $key: string;

    name: string;
    website: string = null;
    type: string = null;
    position: number;

    hasDetailsPage: boolean = false;

    bannerName: string = null;
    bannerUrl: string = null;
    bannerCMId: string = null;

    aboutList = new Array<NewPageList>();
}


// WEBPACK FOOTER //
// /app/src/app/core/models/exhibitor.ts